import React from "react";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";

import loadable from "@loadable/component";
const Contact = loadable(() =>
  import("components/components/molecules/Contact")
);

const SalesPerson = ({ fields }) => {
  const title = getFieldValue(fields, "title");
  const associateName = getFieldValue(fields, "associateName");
  const email = getFieldValue(fields, "email");
  const phoneNumberCall = getFieldValue(fields, "phoneNumberCall");
  const phoneNumberMessage = getFieldValue(fields, "phoneNumberMessage");
  const displayPersonName = getFieldValue(fields, "displayPersonName");
  const personName =
    displayPersonName !== "false" ? getFieldValue(fields, "personName") : null;

  if (!email) {
    return null;
  }

  return (
    <Contact
      title={title}
      associateName={associateName}
      email={email}
      phoneNumberCall={phoneNumberCall}
      phoneNumberMessage={phoneNumberMessage}
      personName={personName}
    />
  );
};

export default SalesPerson;
